import KeenSlider from "keen-slider";

/**
 * Gallery editorial slider init and event listeners
 * @param {Element} sliderWrapperEle - main slider wrapper element
 * @param {Element} popupWrapperEle - Popup slider wrapper element
 */
window.editorialLookbookInit = function editorialLookbookInit(
  sliderWrapperEle,
  popupWrapperEle
) {
  let sliderEle = sliderWrapperEle?.querySelector(".gallery-editorial-slider");
  let popupSliderEle = popupWrapperEle?.querySelector(
    ".gallery-editorial-popup-slider"
  );
  let editorialPopupTriggerEles = sliderWrapperEle?.querySelectorAll(
    ".gallery-editorial-popup-trigger"
  );
  let editorialPopupCloseEle = popupWrapperEle?.querySelector(
    ".close-editorial-popup"
  );

  // init gallery editorial slider
  var slider = new KeenSlider(
    sliderEle,
    {
      loop: true,
      slides: { perView: 1, spacing: 16 },
      rtl: window.rtlView,
      breakpoints: {
        "(min-width: 768px)": {
          slides: { perView: 2, spacing: 30 },
        },
        "(min-width: 1024px)": {
          slides: { perView: 2.5, spacing: 30 },
        },
      },
    },
    [galleryEditorialNavigation]
  );

  // init popup slider
  var sliderPopup = new KeenSlider(
    popupSliderEle,
    {
      loop: true,
      rtl: window.rtlView,
      slides: { perView: 1 },
    },
    [galleryEditorialNavigation]
  );

  // open popup gallery editorial
  editorialPopupTriggerEles.forEach((ele) => {
    ele.addEventListener("click", (e) => {
      let currentIndex = Number(ele.dataset.index);
      // change popup slider active slide
      changePopSliderIndex(currentIndex);
      // show popup slider
      galleryEditorialPopupVisibility(true, popupWrapperEle);
    });
  });

  // Popup Close Listener
  editorialPopupCloseEle.addEventListener("click", (e) => {
    galleryEditorialPopupVisibility(false, popupWrapperEle);
  });

  /**
   * Change popup slider current active slide
   * @param {Number} index - slide position index
   */
  function changePopSliderIndex(index) {
    sliderPopup.moveToIdx(index, false, {
      duration: 0,
    });
  }

  /**
   * Control element Visibility Show (true) or Hide (false)
   * @param {Boolean} status - Show or hide element
   * @param {Element} ele - Element for visibility control
   */
  function galleryEditorialPopupVisibility(status, ele) {
    if (status) {
      ele.classList.remove("hidden");
      document.body.classList.add("lock-scroll");
    } else {
      ele.classList.add("hidden");
      document.body.classList.remove("lock-scroll");
    }
  }

  /**
   * Slider navigation (Only dots)
   * @param {Object} slider - slider object
   */
  function galleryEditorialNavigation(slider) {
    let mainSlider = slider.container.classList.contains(
      "gallery-editorial-slider"
    );

    // Dots are pre-rendered in Liquid (one per block) to avoid layout shift on
    // load. JS only wires up the click + active-state logic here.
    let wrapper = slider.container.closest(".navigation-wrapper");
    let dots = wrapper ? wrapper.querySelector(".dots") : null;
    let dotEls = dots ? Array.from(dots.querySelectorAll(".dot")) : [];

    let dotHandlers = new Map();

    const observer = new ResizeObserver(function () {
      slider.update();
    });

    function bindDots() {
      dotEls.forEach((dot) => {
        const idx = Number(dot.dataset.idx);
        const handler = () => slider.moveToIdx(idx);
        dot.addEventListener("click", handler);
        dotHandlers.set(dot, handler);
      });
    }

    function unbindDots() {
      dotHandlers.forEach((handler, dot) => {
        dot.removeEventListener("click", handler);
      });
      dotHandlers.clear();
    }

    function teardown() {
      observer.disconnect();
      unbindDots();
    }

    function updateClasses() {
      var slide = slider.track.details.rel;
      dotEls.forEach(function (dot, idx) {
        idx === slide
          ? dot.classList.add("dot--active")
          : dot.classList.remove("dot--active");
      });
    }

    // Size the slider to the tallest card currently in view so full-height
    // images are never clipped (desktop), while still fitting the single
    // visible image on mobile.
    function updateHeight() {
      const details = slider.track.details;
      if (!details) return;
      let maxHeight = 0;
      details.slides.forEach((slideDetail, idx) => {
        if (slideDetail.portion <= 0) return;
        const slideWrapper = slider.slides[idx].querySelector(
          ".slide-img-wrapper"
        );
        if (slideWrapper && slideWrapper.offsetHeight > maxHeight) {
          maxHeight = slideWrapper.offsetHeight;
        }
      });
      if (maxHeight > 0) {
        slider.container.style.height = `${maxHeight}px`;
      }
    }

    // Remove the pre-init spacing reserved in CSS so Keen alone controls spacing
    function clearInitialSpacerAroundSlide() {
      slider.slides.forEach((item) => {
        item.style.marginRight = "0px";
        item.style.marginLeft = "0px";
      });
    }

    slider.on("created", () => {
      bindDots();
      updateClasses();
      observer.observe(slider.container);
      if (mainSlider) {
        clearInitialSpacerAroundSlide();
        updateHeight();
      }
    });

    slider.on("updated", () => {
      if (mainSlider) updateHeight();
    });

    slider.on("optionsChanged", () => {
      updateClasses();
      if (mainSlider) updateHeight();
    });

    slider.on("slideChanged", () => {
      updateClasses();
      if (mainSlider) updateHeight();
    });

    slider.on("destroyed", teardown);
  }

  const sectionEl = sliderWrapperEle?.closest(".shopify-section");
  if (sectionEl) {
    sectionEl.addEventListener("shopify:section:unload", () => {
      slider?.destroy();
      sliderPopup?.destroy();
    });
  }
};